import { AliAppletPartnerCode } from 'src/utils/staticData';
/*
 * @authors :Bin Mei
 * @date    :2019-05-02
 * @description： 修改页面标题
 */
import { dmEnv } from '@dm/utils';
import { AlipayMessageOptions } from 'src/components/auth';
import ZALogo from 'src/images/ZALogo.png';
import storage from 'src/utils/storage';
import { setZaAppWebviewNavigationBarTitle } from './open';
import Validate, { validate } from './validate';

declare global {
  interface Window {
    upsdk: any;
  }
}

// 解决IOS在微信内不更新title的bug
export function wechatSetTitle(title: string) {
  document.title = title;
  const i = document.createElement('iframe');
  i.src = ZALogo;
  // i.src = 'https://cdn-qcloud.zhongan.com/a00000/welfare/ZALogo.png';
  i.style.cssText = 'display: none; width: 0; height: 0;';
  const listener = () => {
    setTimeout(() => {
      i.removeEventListener('load', listener);
      setTimeout(() => {
        document.body.removeChild(i);
      }, 20);
    }, 20);
  };
  i.addEventListener('load', listener);
  document.body.appendChild(i);
}

const bridge = {
  setTitle: (title: any) => {
    const defaultTitle = '\u200E';
    const nextTitle = title || defaultTitle;
    if (Validate.isFromWeixin()) {
      wechatSetTitle(nextTitle);
    } else if (dmEnv.isApp()) {
      // dmBridge.setNavigationBarTitle(nextTitle);
      setZaAppWebviewNavigationBarTitle(nextTitle);
    } else if (Validate.isFromUnionPay()) {
      window.upsdk
        && window.upsdk.pluginReady(() => {
          window.upsdk.setNavigationBarTitle({ title: nextTitle });
        });
    } else {
      document.title = nextTitle;
    }
  },
};

/**
 * @description 获取支付宝小程序用户（openId）
 * @returns
 */
export function getAliOpenInfo(): Promise<{aliAppletOpenId; aliAppletPartnerCode}> {
  if (typeof my === 'undefined') {
    return Promise.resolve({} as any);
  }
  // 发送通知
  my.postMessage({ action: 'ALIPAY_APPLET_GET_BASE_INFO' });

  // 再快，他也是异步啊
  return new Promise((resolve) => {
    // 接收通知
    my.onMessage = (message: AlipayMessageOptions) => {
      console.log('onMessage', message);
      if (!message) {
        return;
      }
      const { action, data } = message;
      switch (action) {
        case 'ALIPAY_APPLET_GET_BASE_INFO':
          // eslint-disable-next-line no-case-declarations
          const { aliAppletOpenId, aliAppletPartnerCode } = data || {};
          // 支付宝用户的openId
          storage.set('aliAppletOpenId', aliAppletOpenId);
          // 众安医管家小程序标识
          storage.set('aliAppletPartnerCode', aliAppletPartnerCode);

          resolve({ aliAppletOpenId, aliAppletPartnerCode });
          break;

        case 'ALIPAY_APPLET_REFRESH_PAGE':
          window.location.reload();
          break;
        default:
          console.log('未处理的action！');
          resolve({} as any);
          break;
      }
    };
  });
}

interface PloyFillPlatformLoginOptions {
  preventWhitePage?: boolean; // 是否需要回退来避免空白页面。在被内嵌第三方应用，并且需要拉起对方登录页时处理bug
}
/**
 * @description 不同宿主环境时，采取的不同跳转登录页逻辑
 * @param options
 * @returns
 */
export function ployFillPlatformLogin(options: PloyFillPlatformLoginOptions = {}) {
  const { preventWhitePage = true } = options;
  const { pathname, search } = window.location;
  const redirectTo = pathname + search;

  let miniProgramRedirectTo = `/pages/login/index?redirectTo=${encodeURIComponent(`/pages/webview/index?url=${redirectTo}`)}`;

  // 避免在新的 webview 打开我的页面，底部无 tabbar
  if (pathname === '/my') {
    miniProgramRedirectTo = '';
  }

  if (validate.isFromOwnMiniApplet()) {
    // 不回退会出现白屏，如果用redirectTo会导致webview关闭
    preventWhitePage && window.reactHistory.go(-1);
    return wx.miniProgram.navigateTo({
      url: miniProgramRedirectTo,
    });
  }

  if (validate.isAlipayApplet() && storage.get('aliAppletPartnerCode') === AliAppletPartnerCode.ZA_FSJK) {
    // 不回退会出现白屏，如果用redirectTo会导致webview关闭
    preventWhitePage && window.reactHistory.go(-1);
    // 方伞支付宝小程序登录页
    return my && my.navigateTo({
      url: miniProgramRedirectTo,
    });
  }

  window.reactHistory.replace(`/login?redirectTo=${encodeURIComponent(redirectTo)}`);
}

export default bridge;
